import { parseISO } from 'date-fns';

export function parsePtBRDate(date: string): Date {
  const day = date.split('/')[0];
  const month = date.split('/')[1];
  const year = date.split('/')[2];

  return parseISO(`${year}-${month}-${day}`);
}

export function normalizeDate(dateString: string): Date {
  if (!dateString) return new Date();

  const [datePart] = dateString.split(' ');
  const [year, month, day] = datePart.split('-').map(Number);

  return new Date(year, month - 1, day);
}
